export const LOYALTY_NEW_CHANGE_VALUE = 'LOYALTY_NEW_CHANGE_VALUE';
